import { AbstractCommand } from 'src/models/command';

class SaveTheIdoCommand extends AbstractCommand {
	readonly async = false;
	readonly name = 'IFS_IDO_Command_Command_SaveTheIdoCommand';

	public constructor(idoId: string, idoInstanceId: string, lastKnownChangeTimestamp: string, jsonPayload: string) {
		super();

		const parsedJson = JSON.parse(jsonPayload) as Record<string, boolean | string | string[] | undefined>;

		if (
			Object.prototype.hasOwnProperty.call(parsedJson, 'NETZkultur_IdoModel_FieldTypes_NextContactTime_is_fixed')
		) {
			parsedJson['NETZkultur_IdoModel_FieldTypes_NextContactTime_is_fixed'] = (
				parsedJson['NETZkultur_IdoModel_FieldTypes_NextContactTime_is_fixed'] as Array<string>
			).includes('NETZkultur_IdoModel_FieldTypes_NextContactTime_is_fixed');
		}

		jsonPayload = JSON.stringify(parsedJson);

		this.parameters = {
			idoId: idoId,
			idoInstanceId: idoInstanceId,
			jsonPayload: jsonPayload,
			lastKnownChangeTimestamp: lastKnownChangeTimestamp,
		};
	}
}

export { SaveTheIdoCommand };
